export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              关于8090影院
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              专注打造极致的免费电影大全平台，让每一位影迷都能享受纯粹的高清电影在线观看体验
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/30">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
              <div>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  8090影院成立于2019年，由一群怀揣电影热情的资深影迷共同创立。我们深知观影过程中广告弹窗和卡顿缓冲带来的糟糕体验，因此从第一天起就坚持<strong className="text-foreground-800 font-semibold">免费电影大全</strong>与<strong className="text-foreground-800 font-semibold">电影无广告</strong>两大核心承诺。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  平台聚合超过10万部<strong className="text-foreground-800 font-semibold">国内外大片</strong>资源，涵盖动作、喜剧、科幻、悬疑、爱情、纪录片等全类型。从好莱坞视效巨制到国产口碑佳作，从8090年代经典港片到最新院线热映，我们用心收录每一部值得被看到的好电影。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  依托全国分布式CDN加速网络，8090影院实现了真正意义上的<strong className="text-foreground-800 font-semibold">不缓冲影院</strong>级播放体验。无论你身在何处，都能享受秒加载、零卡顿的<strong className="text-foreground-800 font-semibold">高清电影在线</strong>观看。每天持续更新片库，海量影片随心点播，8090影院愿成为你永不打烊的私人影院。
                </p>
              </div>

              <div className="flex flex-col gap-4">
                {[
                  { icon: 'ri-movie-2-line', title: '10万+影片资源', desc: '覆盖全球100+国家地区的电影作品，类型齐全，持续更新' },
                  { icon: 'ri-shield-check-line', title: '零广告纯净观影', desc: '全站无任何弹窗广告、插播广告，从片头到片尾纯粹享受' },
                  { icon: 'ri-speed-up-line', title: '不缓冲秒加载', desc: '全国多节点CDN加速，智能线路切换，告别卡顿等待' },
                  { icon: 'ri-4k-line', title: '高清画质保障', desc: '支持1080P至4K超高清画质，匹配不同设备和网速需求' },
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3 p-3 rounded-lg hover:bg-background-100/60 transition-colors">
                    <div className="w-9 h-9 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-primary-500 text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-800 mb-0.5">{item.title}</h4>
                      <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}